import React, { Component } from 'react';
import { createRedux } from './store';
import { Router, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import routes from './routes';
import { change } from '$actions/router';
import Cookies from 'js-cookie';
import axios from 'axios';

const token = Cookies.getJSON('token');
if (token) axios.defaults.headers.common['Authorization'] = token;
if (process.muhimma.indexOf(process.target[0]) !== -1) axios.defaults.headers.common['X-Application'] = 'muhimma';
axios.defaults.baseURL = process.env[0].API_URL;

const store = createRedux();

export default class Root extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router
          history={browserHistory}
          routes={routes}
          onUpdate={function() {
            store.dispatch(change(this.state));
            window.scrollTo(0, 0);
          }}
        />
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/root.js